import React from 'react';
import './Suggestion.scss'
import { Suggested } from '../Chatbot';

interface SuggestionProps {
    suggestions: Suggested[];
    updateChatHistory: (question: string, answer: string) => void;
}

const Suggestion: React.FC<SuggestionProps> = ({ suggestions, updateChatHistory }) => {
    return (
        <div className="suggestion-container">
            {suggestions.map((suggestion, index) => (
                <div
                    key={index}
                    className="suggestion-item"
                    onClick={() => updateChatHistory(suggestion.suggested_question, suggestion.answer)}
                >
                    {suggestion.suggested_question}
                </div>
            ))}
        </div>
    );
};

export default Suggestion;
